:host {
  display: inline-flex;
  max-width: 80%;
  box-sizing: border-box;
  -webkit-user-select: text;
  user-select: text;
}

.message-bubble {
  min-width: 0;
  padding-block: var(--dimension-space-100);
  padding-inline: calc(var(--dimension-space-100) + var(--dimension-space-025));
  border-radius: var(--dimension-radius-050);
  background: transparent;
  color: var(--color-foreground-primary);
  font-family: var(--typography-font-family-ui);
  font-size: var(--typography-fontsize-md);
  line-height: var(--typography-lineheight-md);
  font-weight: var(--typography-weight-regular);
  letter-spacing: var(--typography-letterspacing-negative-half);
  box-sizing: border-box;
  overflow-wrap: anywhere;
}

:host(.message-bubble--user) .message-bubble {
  background: var(--color-translucent-translucent);
  color: var(--color-foreground-secondary);
  box-shadow: inset 0 0 0 var(--dimension-stroke-width-012) var(--color-border-tertiary);
}

:host(.message-bubble--received) .message-bubble {
  box-shadow: inset 0 0 0 var(--dimension-stroke-width-012) var(--color-border-tertiary);
}
